import { PaletteMode } from '@mui/material';
import { createContext } from 'react';

const PaletteModeContext = createContext<PaletteMode>('light');

export default PaletteModeContext;
